/**
 * Constants for file upload functionality
 * Centralized configuration for upload-related operations
 */

/**
 * Maximum length for file and folder names in characters
 * This matches the database column constraint
 */
export const MAX_NAME_LENGTH = 191;

/**
 * Maximum length for legal category names
 */
export const MAX_LEGAL_CATEGORY_NAME_LENGTH = 30;

/**
 * File upload dialog types
 * Defines the context in which the upload dialog is used
 */
export const UPLOAD_DIALOG_TYPES = {
  /** Standard file/folder upload */
  ASSETS: 'assets',
  /** Subtitle file upload (.srt, .vtt) */
  SUBTITLES: 'subtitles',
  /** Legal document upload (.pdf, .docx, .doc) */
  LEGAL: 'legal',
};

/**
 * Accepted file extensions by dialog type
 */
export const ACCEPTED_EXTENSIONS = {
  [UPLOAD_DIALOG_TYPES.LEGAL]: {
    mimeTypes: 'application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword',
    extensions: ['pdf', 'docx', 'doc'],
  },
  [UPLOAD_DIALOG_TYPES.SUBTITLES]: {
    mimeTypes: '.srt, .vtt',
    extensions: ['srt', 'vtt'],
  },
};

/**
 * Asset type identifiers
 */
export const ASSET_TYPES = {
  AUTO: 8,
  THUMBNAIL: 1,
  SUBTITLE: 7,
  AUDIODESCRIPTION: 13,
};

/**
 * Legal category identifiers
 */
export const LEGAL_CATEGORIES = {
  QUIT_CLAIM: 1,
  RIGHTS_AGREEMENT: 2,
  RELEASE_FORM: 3,
  OTHER: 4,
};

/**
 * Upload status constants
 * These should match the store's status definitions
 */
export const UPLOAD_STATUSES = {
  ADDED: 1,
  WAITING: 2,
  UPLOADING: 3,
  FINISHED: 4,
  ERROR: 5,
  CANCELLED: 6,
};

/**
 * Drag and drop related constants
 */
export const DRAG_DROP = {
  /** Minimum drag counter value before hiding drop zone */
  MIN_COUNTER: 0,
};

/**
 * Validation error message keys
 * These correspond to i18n translation keys
 */
export const VALIDATION_ERRORS = {
  FOLDER_SEGMENT_TOO_LONG: 'menus.uploadFiles.folderSegmentTooLong',
  FILE_NAME_TOO_LONG: 'menus.uploadFiles.fileNameTooLong',
  ACTIVE_NODE_REQUIRED: 'menus.uploadFiles.activeNodeRequired',
  INSUFFICIENT_STORAGE: 'menus.uploadFiles.insufficientStorage',
  LEGAL_CATEGORY_REQUIRED: 'menus.uploadFiles.pleaseSelectLegalCategory',
  DUPLICATE_FILE: 'menus.uploadFiles.duplicateFile',
  DUPLICATE_FILES: 'menus.uploadFiles.duplicateFiles',
};
